export default __webpack_public_path__ + "static/media/down-arrow.3dabf200.svg";